<template>
  <div class="content">
    <div class="info-card-wrap">
      <!-- 剩余余额卡片 -->
      <div class="info-card balance-card">
        <div class="card-text">可创建子账号数量：{{ total }}</div>
      </div>
      <div class="add" @click="handleAdd">添加子账号</div>
    </div>
    <!-- 表格卡片 -->
    <div class="table-card">
      <el-table
          :data="tableData"
          border
          stripe
          size="medium"
          style="width: 100%"
      >
        <el-table-column prop="id" label="序号" width="80" align="center"/>
        <el-table-column prop="phone" label="登录账号（手机号）" align="center">
        </el-table-column>
        <el-table-column prop="nickname" label="姓名" align="center"></el-table-column>
        <!--        <el-table-column prop="password" label="密码" align="center"></el-table-column>-->
        <el-table-column prop="remark" label="备注" :show-overflow-tooltip="true" align="center"/>
        <el-table-column prop="create_at" label="注册时间" align="center"/>
        <el-table-column label="操作" align="center" width="250">
          <template slot-scope="scope">
            <!--            <el-button type="text" @click="handleView(scope.row)">查看</el-button>-->
            <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 添加/编辑/详情 共用弹窗 -->
    <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="500px"
        :close-on-click-modal="false"
    >
      <el-form
          :model="form"
          :rules="formRules"
          ref="formRef"
          label-width="100px"
          :disabled="isView"
      >
        <el-form-item label="登录账号" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入登录账号（手机号）" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="nickname">
          <el-input v-model="form.nickname" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password" v-if="!isView">
          <el-input
              v-model="form.password"
              placeholder="请输入密码(不填写默认使用账号)"
              show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" v-else>
          <el-input v-model="form.password" disabled></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
              v-model="form.remark"
              type="textarea"
              :rows="3"
              placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="!isView">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
      </div>
      <div slot="footer" class="dialog-footer" v-else>
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {staffList, staffInfo, staffEdit, staffDel, userInfo} from "@/api/api";

  export default {
    name: "index",
    data() {
      return {
        tableData: [],
        page: 1,
        limit: 10,
        total: 0,
        info: {},

        // 弹窗相关
        dialogVisible: false,
        dialogType: "add", // add / edit / view
        submitLoading: false,
        form: {
          id: 0,
          phone: "",
          nickname: "",
          password: "",
          remark: "",
        },
        formRules: {
          phone: [
            {pattern: /^1[3-9]\d{9}$/, message: "手机号格式不正确", trigger: "blur"},
          ],
          // nickname: [
          //   { required: true, message: "请输入姓名", trigger: "blur" },
          // ],
          // password: [
          //   { required: true, message: "请输入密码", trigger: "blur" },
          //   { min: 6, message: "密码长度不能少于6位", trigger: "blur" },
          // ],
        },
      };
    },
    computed: {
      dialogTitle() {
        if (this.dialogType === "add") return "添加子账号";
        if (this.dialogType === "edit") return "编辑子账号";
        return "子账号详情";
      },
      isView() {
        return this.dialogType === "view";
      },
    },
    mounted() {
      this.staffList();
      this.userInfo()
    },
    methods: {
      userInfo() {
        userInfo().then(res => {
          this.total = Number(res.data.sub_num_max) - Number(res.data.has_sub_num)
        })
      },
      handleSizeChange(val) {
        this.limit = val;
        this.staffList();
      },
      handleCurrentChange(val) {
        this.page = val;
        this.staffList();
      },
      staffList() {
        let params = {
          page: this.page,
          limit: this.limit,
        };
        staffList(params).then((res) => {
          this.tableData = res.data.list;
          // this.total = res.data.page.total;
        });
      },

      // 重置表单
      resetForm() {
        this.form = {
          id: 0,
          phone: "",
          nickname: "",
          password: "",
          remark: "",
        };
        this.$nextTick(() => {
          this.$refs.formRef && this.$refs.formRef.clearValidate();
        });
      },

      // 添加
      handleAdd() {
        this.dialogType = "add";
        this.resetForm();
        this.dialogVisible = true;
      },

      // 编辑
      handleEdit(row) {
        this.dialogType = "edit";
        this.resetForm();
        this.dialogVisible = true;
        // 获取详情数据填充表单
        staffInfo({id: row.id}).then((res) => {
          if (res.code === 200 || res.code === 1) {
            const data = res.data;
            this.form = {
              id: data.id,
              phone: data.phone || "",
              nickname: data.nickname || "",
              password: data.password || '',
              remark: data.remark || "",
            };
          }
        });
      },


      // 删除
      handleDelete(row) {
        this.$confirm("确认删除该子账号？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          staffDel({id: row.id}).then((res) => {
            if (res.code === 200 || res.code === 1) {
              this.$message.success("删除成功");
              this.staffList();
              this.userInfo()
            } else {
              this.$message.error(res.msg || "删除失败");
            }
          });
        }).catch(() => {
        });
      },

      // 提交（添加/编辑）
      handleSubmit() {
        this.$refs.formRef.validate((valid) => {
          if (!valid) return;

          this.submitLoading = true;
          const params = {...this.form};

          // 添加时 id 传 0
          if (this.dialogType === "add") {
            params.id = 0;
          }

          staffEdit(params)
              .then((res) => {
                this.submitLoading = false;
                if (res.code === 200 || res.code === 1) {
                  this.$message.success(
                      this.dialogType === "add" ? "添加成功" : "编辑成功"
                  );
                  this.dialogVisible = false;
                  this.staffList();
                  this.userInfo()
                } else {
                  this.$message.error(res.msg || "操作失败");
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
        });
      },
    },
  };
</script>

<style scoped lang="less">
  // 表格卡片样式
  .table-card {
    margin-top: 20px;
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    /*box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);*/
    border: 1px solid #f1f1f1;
  }

  // 分页样式
  .page {
    margin-top: 20px;
    text-align: right;
  }

  // 外层容器：两个卡片横向排列、间距自适应
  .info-card-wrap {
    display: flex;
    gap: 30px;
    margin-bottom: 24px;
    flex-wrap: wrap;
    position: relative;

    .add {
      position: absolute;
      right: 20px;
      top: 20px;
      font-size: 20px;
      color: #ffffff;
      font-weight: 500;
      cursor: pointer;
      user-select: none;
    }

    // 通用卡片样式 完全匹配截图深蓝色圆角
    .info-card {
      flex: 1;
      min-width: 320px;
      background: #2f3ced;
      border-radius: 12px;
      padding: 20px;
      display: flex;
      align-items: center;
      gap: 24px;

      // 图标样式
      .card-icon {
        width: 50px;
        height: 50px;
      }

      // 文字样式 白色居中
      .card-text {
        font-size: 20px;
        color: #ffffff;
        font-weight: 500;
      }
    }
  }

  // 弹窗表单样式微调
  .dialog-footer {
    text-align: right;
  }
</style>
